import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  flex: initial !important;
  display: flex;
  justify-content: flex-end;
`;

export const ToggleExtraButton = styled.div`
  margin-left: 10px;
`;
